import React, { useState } from 'react';
import { useEffect } from 'react';
import { ContentContainer, Row, Col, Button, RadioButtonList, pxToRem, tokens, FormHeader, InPageAlert, ErrorSummary } from '@snsw-gel/react';
import { dataLayer } from '../../services/gtm-dataLayer';
import styles from './CurrentStatus.module.scss';

const CurrentStatusPage = () => {
    const [hasExistingCard, setHasExistingCard] = useState(null);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);
    }, []);

    useEffect(() => {
        document.querySelector("legend>span").setAttribute('aria-hidden', 'true');
        document.getElementById("hasExistingCard-0").setAttribute('aria-hidden', 'true');
        document.getElementById("hasExistingCard-1").setAttribute('aria-hidden', 'true');
    }, []);


    const onChangeEvent = v => {
        setHasExistingCard(v);
    };

    const onSubmitPage = () => {
        setHasError(false)
        if (hasExistingCard === null) {
            setHasError(true);
            return;
        }
        if (hasExistingCard === 'true') {
            localStorage.setItem('soFlow', 'link');
            window.location.href = process.env.REACT_APP_SERVICE_ORCHESTRATOR_LINKING_URL;
        } else {
            window.location.href = 'https://www.service.nsw.gov.au/transaction/apply-nsw-seniors-card-or-nsw-senior-savers-card';
        }
    };

    return (
        <>
            <FormHeader
                label='Apply or manage a NSW Seniors Card or NSW Senior Savers Card'
                title='Before you start'
            />
            <ContentContainer className={styles['content-container']}>
                <Row>
                    <Col span={6}>
                        {hasError &&
                           <div className={styles['error-margin']}>
                            <ErrorSummary  errors={[{ id: 'hasExistingCard', text: 'Select an option to continue.' }]} />
                            </div>}
                        <InPageAlert variant='info' title='You will need to verify your identity'
                        //  className={styles['alert']}>
                           className= {`${styles['alert']} ${hasError ? styles['has-error'] : ''}`}>
                            <p>You may need details from 2 identity documents.</p>
                        </InPageAlert>

                        <RadioButtonList
                            id='hasExistingCard'
                            name='hasExistingCard'
                            legend='What do you want to do?'
                            vertical={true}
                            options={[
                                { value: 'false', label: 'Apply for a card' },
                                { value: 'true', label: 'Manage your existing card online (you need your card number)' },
                            ]}
                            onChange={onChangeEvent}
                            hasError={hasError}
                            errorMessage='Select an option to continue.'
                            value={hasExistingCard}
                        />

                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['continue-button']}
                            style={{ marginTop: `${pxToRem(tokens.spacing.xl)}` }}
                            id='applyButton'
                            onClick={onSubmitPage}
                            aria-label='Continue'
                        >
                            Continue
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['back-link']}
                            style={{ marginTop: `${pxToRem(tokens.spacing.xl)}` }}
                            variant="link"
                            href={process.env.REACT_APP_ADD_SERVICE_URL}
                            aria-label='Go back'
                        >
                            Back
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default CurrentStatusPage;

